import script from "./PoolCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./PoolCompanies.vue?vue&type=script&setup=true&lang=js"

import "./PoolCompanies.vue?vue&type=style&index=0&id=218bcfd4&lang=css"

const __exports__ = script;

export default __exports__